import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ApiService, { initialAuthState } from "../Services/ApiServices";
import "./Login.css";
import Navbar from "../New_Templates/Navbar";
import Footer from "../New_Templates/Footer";
import { CartContext } from "../../contexts/CartContext";
import { BiSolidMapPin } from "react-icons/bi";
import { TfiTruck } from "react-icons/tfi";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { MdLockOutline } from "react-icons/md";

function LoginPage() {
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();
  const { addToCart } = useContext(CartContext);
  const [loading, setLoading] = useState(false);

  const handleSendCode = async () => {
    if (phone.length !== 10) {
      alert("Enter a valid 10-digit number");
      return;
    }

    try {
      setLoading(true);
      const response = await ApiService.post("otp/sendClientOtp", {
        companyCode: initialAuthState.companyCode,
        unitCode: initialAuthState.unitCode,
        phoneNumber: phone,
      });

      if (response.status) {
        navigate("/verify-otp", { state: { phone } });
      } else {
        alert("Error sending OTP");
      }
    } catch (error) {
      console.error("OTP error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSendCode();
    }
  };

  return (
    <>
      {/* <Navbar /> */}

      <div className="Login-wrapper">
        <div className="Login-bg-anim"></div>

        <div className="Login-card">

          {/* LEFT */}
          <div className="Login-left">
            <div className="Login-left-content">

              <img
                src="/images/way4track-login-image.webp"
                alt="GPS Tracking"
                className="Login-image"
              />

              <div className="Login-overlay-text">
                <h2>Track Every Vehicle. Every Minute.</h2>
                <p> Monitor your vehicles in real-time, reduce fuel misuse, and stay in control
                  of your operations from one dashboard.</p>

                <div className="Login-features">
                  <span><BiSolidMapPin /> Live Tracking</span>
                  <span><TfiTruck /> Fleet Control</span>
                  <span><BsFillFuelPumpFill /> Fuel Insights</span>
                  <span><MdLockOutline /> Theft Alerts</span>
                </div>
              </div>

            </div>
          </div>

          {/* RIGHT */}
          <div className="Login-right">
            <div className="Login-form">

              <div className="Login-brand">
                <h2>Way4Track</h2>
                <p>Track Anything, Anytime,Anywhere</p>
              </div>

              <h3 className="Login-title">Login / Signup</h3>

              <div className="Login-input-group">
                <span className="Login-prefix">+91</span>
                <input
                  type="tel"
                  placeholder="Enter mobile number"
                  value={phone}
                  maxLength={10}
                  onChange={(e) =>
                    setPhone(e.target.value.replace(/\D/g, ""))
                  }
                  onKeyDown={handleKeyDown}
                />
              </div>

              <button
                className={`Login-btn ${loading ? "loading" : ""}`}
                onClick={handleSendCode}
                disabled={loading}
              >
                {loading ? "Sending OTP..." : "Continue"}
              </button>

              <div className="Login-policy">
                By continuing, you agree to our <br />
                <a href="/termsandconditions">Terms & Conditions</a> and{" "}
                <a href="/termsandconditions">Privacy Policy</a>
              </div>

            </div>
          </div>

        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
}

export default LoginPage;



// import React, { useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import ApiService, { initialAuthState } from "../Services/ApiServices";

// import "./Login.css";

// function LoginPage() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [phone, setPhone] = useState("");
//   const [error, setError] = useState("");

//   const companyCode = initialAuthState.companyCode;
//   const unitCode = initialAuthState.unitCode;

//   // Redirect path, fallback to '/' if no previous route found
//   const redirectPath = location.state?.from?.pathname || "/";

// const handleLogin = async () => {
//   try {
//     const response = await ApiService.post("client/clientLoginDetails", {
//       companyCode,
//       unitCode,
//       phoneNumber: phone,
//     });

//     if (response.status) {
//       const { id, clientId, phoneNumber } = response.data;

//       localStorage.setItem("client_id", clientId);
//       localStorage.setItem("client_db_id", id);
//       localStorage.setItem("client_phone", phoneNumber);


//       // Redirect to the previous location or homepage
//       navigate(redirectPath, { replace: true });
//     } else {
//       handleRegister();
//     }
//   } catch (error) {
//     console.error("Error during login:", error);
//   }
// };

//   const handleRegister = async () => {
//     try {
//       const response = await ApiService.post("/client/handleClientDetails", {
//         companyCode,
//         unitCode,
//         phoneNumber: phone,
//       });

//       if (response.status) {
//         const { id, clientId, phoneNumber } = response.data;

//         localStorage.setItem("client_id", clientId);
//         localStorage.setItem("client_db_id", id);
//         localStorage.setItem("client_phone", phoneNumber);

//         // Navigate back to the previous location after successful registration
//         navigate(redirectPath, { replace: true });
//       } else {
//         alert("Error during registration.");
//         console.error("Failed to fetch cart items:", response.message);
//       }
//     } catch (error) {
//       console.error("Error during registration:", error);
//     }
//   };

//   return (
//     <div className="login-container">
//       <div className="login-box">
//         <div className="logo-section">
//           <img src="/images/logo.png" alt="logo" className="logo-square" />
//         </div>

//         <h2>Login with Phone</h2>
//         <div className="input-group">
//           <input
//             type="tel"
//             className="login-input"
//             placeholder="Enter phone number"
//             value={phone}
//             onChange={(e) => {
//               setPhone(e.target.value);
//               setError(""); // Reset error when typing
//             }}
//             maxLength={10}
//           />
//         </div>

//         {error && <p className="error-text">{error}</p>}

//         <button className="login-btn" onClick={handleLogin}>
//           Login
//         </button>
//       </div>
//     </div>
//   );
// }

// export default LoginPage;
